export type ProductCategoriesDialogMessages = {
  // Dialog Titles
  deleteCategoryDialogTitle: string;

  // Dialog Content Messages
  deleteCategoryDialogContent: string;
  deleteCategoryDialogCancel: string;
  deleteCategoryDialogConfirm: string;
  deleteCategorySuccess: string;
};

export const PRODUCT_CATEGORIES_DIALOG_MESSAGES: ProductCategoriesDialogMessages = {
  // Dialog Titles

  deleteCategoryDialogTitle: "Excluir Categoria",

  // Dialog Content Messages
  deleteCategoryDialogContent: "Tem certeza de que deseja excluir esta categoria?",
  deleteCategoryDialogCancel: "Cancelar",
  deleteCategoryDialogConfirm: "Confirmar",
  deleteCategorySuccess: "Categoria excluída com sucesso!",
};
